import TableAntd from "components/elements/Table";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import styles from "../styles/MyTimesheet.module.css";
import { Space, Table } from "antd";
import { ReactComponent as UpIcon } from "../../../assets/icon/upArrow.svg";
import { ReactComponent as DownIcon } from "../../../assets/icon/downArrown.svg";

const MyTimesheetTable = ({
    columns = [],
    transformTimesheetData = [],
    timesheetCalendar = [],
}) => {
    const { isLoading } = useSelector((state) => state.myTimesheet);

    const scroll = useMemo(() => {
        return {
            x: 3000,
            scroll: true
        };
    }, []);

    const CustomExpandIcon = ({ expanded, onExpand, record }) => {
        if (!record.children || record.children.length === 0) {
            return <span style={{ marginRight: 16 }} />; // spacing ให้ align
        }

        return (
            <div
                onClick={(e) => onExpand(record, e)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 24,
                    height: '100%',
                    cursor: 'pointer',
                }}
            >
                {expanded ? <UpIcon /> : <DownIcon />}
            </div>
        );
    };

    return (
        <Table
            loading={isLoading}
            dataSource={transformTimesheetData(timesheetCalendar)}
            columns={columns}
            scroll={scroll}
            rowKey="key"
            pagination={false}
            bordered={true}
            expandable={{
                expandIcon: CustomExpandIcon,
                indentSize: 0,
                expandIconColumnIndex: 0,
            }}
            rowClassName={(record) => {
                if (record.type === 'project') {
                    return styles.projectRow;
                }
                if (record.type === 'summaryDay') {
                    return styles.summaryDay;
                }
                if (record.type === 'role') {
                    return styles.roleRow;
                }
                if (record.type === 'task' && Array.isArray(record.children) && record.children.length > 0) {
                    return styles.taskWithSuntaskRow;
                }
                return '';
            }}
            className={styles.tableCalendar}
        />
    )
}

export default MyTimesheetTable;